module.exports = __webpack_public_path__ + "static/img/notification-banner-sizing@3x.cbb3ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notification-banner-sizing@3x.png
// module id = 3rOF
// module chunks = 0